export const DEFAULT_FIRST_SCREEN = {
  id: 'a87b18e1-0dc5-4958-b02e-6d0fd6ffa1b2',
  type: 'AGE_FLEXIBLE',
  scope: 'Default',
  parameters: {
    ageFilter: [],
    ages: [],
    hideGoBackBtn: true,
    logo: true,
    name: 'NewOB_08_24_001',
    noCountForStep: true,
    pictures: ['1-2', '3-4', '5-6', '7+'],
    question: ' ',
    questions: [],
    requiredAnswer: true,
    result: [],
    stepHidden: true,
    subjects: ['1–2', '3–4', '5–6', '7+'],
    text: ' ',
    title: 'Keiki_AgePicture_1-1',
    withoutButton: true
  },
  blocks: null,
  updated_at: 1722603600852,
  locked: false
};
